<template>
  <v-form>
    <v-row dense>
      <v-col cols="12" md="4">
        <v-text-field
          autocomplete="off"
          type="text"
          outlined
          dense
          label="Type Name"
          v-model="record.Name"
        ></v-text-field>
      </v-col>

      <v-col cols="12">
         <v-btn v-if="docCreate == true" color="accent" @click="sendData" :loading="$store.state.btnLoader">
          <v-icon left>mdi-content-save</v-icon>Save
        </v-btn>

        <v-btn v-else color="accent" @click="sendData" :loading="$store.state.btnLoader">
          <v-icon left>mdi-content-save</v-icon>Update
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>


<script>
export default {
  name: "CategoriesEditor",
  props: {
    initial: {
      type: Object,
      required: true,
    },
    docCreate: {
      type: Boolean
    }
  },
  data: () => ({
    record: {},
    loader: false,
    categories: [],
    date: new Date().toISOString().substr(0, 10),
  }),
  watch: {
    initial: {
      handler: "init",
      immediate: true,
    },
  },
  methods: {
    init(val) {
      this.record = { ...val };
    },
    setDate(date) {
      this.record.date = date;
    },
    sendData() {
      this.loader = true;
      this.$store.commit("btnLoader", true);
      this.$emit("data", this.record);
    }
  },
  created() {
    
  },
};
</script>